import { Button, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";


export default function ComingSoon() {
    const navigate = useNavigate()
    return (
        <div className="comingsoon text-center">
            <Container>
                <h1>Coming Soon</h1>
                <p>Our new page is coming soon with up-to-date content for healthcare professionals and learners alike.</p>
                <Button variant="primary" onClick={() => navigate('/')}>Back to Home</Button>
            </Container>
        </div>
    )
}